// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.alertTooltip__uKieu {
  width: 166px;
  min-height: 215px;
  text-align: left;
  background-color: var(--tables-primary-row-surface-default);
  opacity: 1;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
}

.tooltipContainer__M3xMI {
  padding: 8px;
}

.tooltipTitle__yGywD {
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  color: var(--tables-primary-row-text-main);
  text-transform: uppercase;
  padding: 7px 0;
  border-bottom: 1px solid #ebedf1;
}

.tooltipBody__N4VS9 {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  margin-top: 8px;
}

.alertInfo__xaYCy {
  font-size: 11px;
  line-height: 12px;
  color: var(--tables-primary-row-text-additional);
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.alertInfoValue__l0AXR {
  color: var(--tables-primary-row-text-main);
}

.tooltipInfo___OfNh {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-additional);
  padding-top: 10px;
  border-top: 1px solid #ebedf1;
}

.tooltipBtn__C0upR {
  justify-content: flex-start;
}

.tooltipLink__wbWr6 {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/ChartAlertTooltip/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,2DAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;EACA,cAAA;EACA,gCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,0CAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,iBAAA;EACA,6BAAA;AAzEF;;AA4EA;EACE,2BAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\ndiv.alertTooltip {\n  width: 166px;\n  min-height: 215px;\n  text-align: left;\n  background-color: var(--tables-primary-row-surface-default);\n  opacity: 1;\n  padding: 8px;\n  border-radius: 4px;\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n}\n\n.tooltipContainer {\n  padding: 8px;\n}\n\n.tooltipTitle {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-main);\n  text-transform: uppercase;\n  padding: 7px 0;\n  border-bottom: 1px solid #ebedf1;\n}\n\n.tooltipBody {\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n  margin-top: 8px;\n}\n\n.alertInfo {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-additional);\n  height: 22px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.alertInfoValue {\n  color: var(--tables-primary-row-text-main);\n}\n\n.tooltipInfo {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-additional);\n  padding-top: 10px;\n  border-top: 1px solid #ebedf1;\n}\n\n.tooltipBtn {\n  justify-content: flex-start;\n}\n\n.tooltipLink {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  text-transform: uppercase;\n  text-decoration: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertTooltip": `alertTooltip__uKieu`,
	"tooltipContainer": `tooltipContainer__M3xMI`,
	"tooltipTitle": `tooltipTitle__yGywD`,
	"tooltipBody": `tooltipBody__N4VS9`,
	"alertInfo": `alertInfo__xaYCy`,
	"alertInfoValue": `alertInfoValue__l0AXR`,
	"tooltipInfo": `tooltipInfo___OfNh`,
	"tooltipBtn": `tooltipBtn__C0upR`,
	"tooltipLink": `tooltipLink__wbWr6`
};
module.exports = ___CSS_LOADER_EXPORT___;
